/**
 * Descriptions for product fields, shown as info tooltips next to field
 * labels (issue #72). Keyed by the form field name so Create/Edit/Detail
 * pages stay in sync.
 */
export const productFieldDescriptions = {
  name: "The official name of the product as it should appear across ProdAtlas, reports and exports.",
  businessArea:
    "The Sandvik business area that owns this product. Determines which admins and approvers can manage it.",
  division:
    "The division/business unit within the selected business area that is responsible for the product.",
  category:
    "A short free-text label for the kind of product, e.g. Web Application, Mobile App or Embedded System.",
  description:
    "A short summary of what the product does and who it is for. Helps others find and understand the product.",
  apmNumber:
    "The product's identifier in the APM (Application Portfolio Management) register, if it has one.",
  developmentResponsibility:
    "Who develops the product: Sandvik (in-house), a Supplier (external vendor) or a Sub-Contractor working on Sandvik's behalf.",
  customization:
    "Whether the product is Customized (built or tailored for Sandvik) or COTS (commercial off-the-shelf, used as delivered).",
  lifecycleStatus:
    "Where the product is in its lifecycle: Planned, In Development, Released, Retired or Obsolete.",
  productResponsibleId: "The person accountable for the product day to day.",
  businessAccountableId:
    "The person with business accountability for this product.",
  sdlResponsibleId:
    "The person responsible for this product's Secure Development Lifecycle (SDL) activities.",
  craClassification:
    "The product's classification under the EU Cyber Resilience Act: Critical, Important I, Important II, Default or Out of Scope. Determines which conformity assessment route applies.",
  keyProduct:
    "Marks the product as strategically important. Signals to business area and division admins that the product needs extra attention.",
} as const;
